<template>
    <div v-bind:class="$style.card">
        <div v-if="featured" v-bind:class="$style.label">
            Featured
        </div>
        <AppLink v-bind:href="card.urls[0].url">
            <AppImage
                v-if="card.image"
                v-bind:image="card.image"
                v-bind:class="$style.image"
                crop-height="24rem"
            />
        </AppLink>
        <div v-bind:class="$style.content">
            <AppLink v-bind:href="card.urls[0].url">
                <h2
                    v-bind:class="[
                        $style.title,
                        {
                            [$style.offset] : !card.image && featured,
                        },
                    ]
                    "
                >
                    {{ card.title }}
                </h2>
            </AppLink>
            <p v-bind:class="$style.description">
                {{ card.description }}
            </p>
            <a v-bind:href="card.urls[0].url">
                {{ card.__meta__.comments_count }} Comment
                <span v-if="card.__meta__.comments_count === 1">s</span>
            </a> | Latest comment: {{ humanReadableDate }}
        </div>
    </div>
</template>

<script>
    import humanReadableDate from '@utilities/humanReadableDate';

    export default {
        /**
         * Define the properties passed into the component from the parent.
         *
         * @link https://vuejs.org/v2/guide/components.html#Props
         */
        props: {
            card: {
                type: Object,
                required: true,
            },
            featured: {
                type: Boolean,
                default: false,
            },
        },

        /**
         * You must define defaults for all Vue models and reactive Vue template data.
         *
         * @link https://vuejs.org/v2/api/#data
         *
         * @return Object Vue model and binding defaults.
         */
        data () {
            return {
                humanReadableDate: null,
            };
        },
        created () {
            this.humanReadableDate = humanReadableDate(this.card.updated_at);
        },
    };
</script>

<style lang="scss" module>
    @import '@design';

    .card {
        @apply border-white border border-solid bg-white m-2 cursor-pointer relative;

        @extend %grow;
    }

    .offset {
        margin-top: 2.5rem;
    }

    .label {
        @apply absolute top-0 left-0 bg-citizen-gray-500 pl-4 pr-8 py-1 text-citizen-gold font-bold;
        clip-path: polygon(0 0, 100% 0, calc(100% - 1rem) 100%, 0% 100%);
    }

    .image {
        img {
            @apply w-full;
        }
    }

    .content {
        @apply p-2;
    }

    .title {
        @apply font-black text-xl;
    }

    .description {
        @apply mt-1;
    }
</style>
